import { createContext, type PropsWithChildren, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CreateStore } from 'pages/clients/pages/create/store/createStore'

export const CreateContext = createContext<CreateStore | null>(null)

export const useCreateContext = () => {
  const context = useContext(CreateContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with CreateContext')

  return context
}

export const CreateProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const { state } = useLocation()
  const [store] = useState(() => new CreateStore(entities, state?.duplicateId))

  useEffect(() => {
    store.init()
    return () => store.dispose()
  }, [])

  return <CreateContext.Provider value={store}>{children}</CreateContext.Provider>
}
